var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 4.953c-.826-.028-1.375.194-1.709.646-.451-.396-1.18-.646-1.8-.646-1.889 0-2.875 1.258-2.875 2.535 0 .89.472 1.446 1.083 1.946-.326.09-1.139.626-1.139 1.327 0 .785.743.973 1.084 1.182v.027c-.632 0-1.32.437-1.32 1.347 0 1.154 1.292 1.737 3.258 1.737 2.328 0 3.377-1.118 3.377-2.16 0-2.918-4.801-1.32-4.801-2.494 0-.424.604-.452 1.362-.452 1.827 0 2.75-.98 2.75-2.362 0-.556-.166-.98-.388-1.286.264-.166.715-.166 1.118-.166V4.953zM18 10.004c0 2.209-.896 4.21-2.341 5.662a7.976 7.976 0 0 1-5.656 2.34h-.006C5.577 18.007 2 14.424 2 10.005c0-2.21.896-4.21 2.341-5.663A7.976 7.976 0 0 1 9.997 2h.006C14.423 2 18 5.585 18 10.004zm-7.802 3.905c1.119 0 1.5-.564 1.5-.813 0-.341-.52-.848-2.202-.848-.958 0-1.236.535-1.236.848 0 .556.472.813 1.938.813zm.813-6.455c0 .674-.535 1.202-1.195 1.202-.743 0-1.265-.528-1.265-1.202 0-.673.522-1.21 1.265-1.21.66 0 1.195.537 1.195 1.21z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetty);
export default __webpack_public_path__ + "static/media/getty.736aa50efda945b69d5086c58fa0d749.svg";
export { ForwardRef as ReactComponent };